import React, { useState, useEffect, useContext } from "react";
import AuthenticationContext from "../contexts/auth/Auth.context";
import axios from "axios";
import { BOOKMARK_POST } from "../contexts/types.js";
import { config as axiosConfig, ALL_POSTS_URL } from "../config/constants";
import { CircularProgress, Typography } from "@material-ui/core";
import Navbar from "../components/Navbar";
import Page from "../components/common/Page";
import PostCard from "../components/common/PostCard";

const config = axiosConfig(localStorage.getItem("jwt"));
const Home = () => {
  const { dispatch } = useContext(AuthenticationContext);
  const [fetchingData, setFetchingData] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setFetchingData(true);
    axios.get(ALL_POSTS_URL, config).then((res) => {
      setData(res.data.posts);
      setFetchingData(false);
    });
  }, []);

  const likePost = (id) => {
    axios
      .put(`http://localhost:5000/like`, { postId: id }, config)
      .then((result) => {
        const newData = data.map((item) => {
          if (result.data._id === item._id) return result.data;
          else return item;
        });
        setData(newData);
      })
      .catch((err) => console.log(err));
  };

  const unlikePost = (id) => {
    axios
      .put(`http://localhost:5000/Unlike`, { postId: id }, config)
      .then((res) => {
        const newData = data.map((item) => {
          if (res.data._id === item._id) return res.data;
          else return item;
        });
        setData(newData);
      })
      .catch((err) => console.log(err));
  };

  const bookmark = (id) => {
    axios
      .put(`http://localhost:5000/bookmark-post`, { postId: id }, config)
      .then((result) => {
        dispatch({
          type: BOOKMARK_POST,
          payload: { Bookmarks: result.data.Bookmarks },
        });
        localStorage.setItem("user", JSON.stringify(result.data));
      })
      .catch((err) => console.log(err));
  };

  const removeBookmark = (id) => {
    axios
      .put(`http://localhost:5000/remove-bookmark`, { postId: id }, config)
      .then((result) => {
        dispatch({
          type: BOOKMARK_POST,
          payload: { Bookmarks: result.data.Bookmarks },
        });
        localStorage.setItem("user", JSON.stringify(result.data));
      })
      .catch((err) => console.log(err));
  };

  const makeComment = (text, postId) => {
    // setComment("");
    axios
      .put(`http://localhost:5000/comment`, { text, postId }, config)
      .then((result) => {
        const newData = data.map((item) => {
          if (result.data._id === item._id) return result.data;
          else return item;
        });
        setData(newData);
      })
      .catch((err) => console.log(err));
    // setComment("");
  };

  const deletePost = (postId) => {
    axios
      .delete(`http://localhost:5000/deletepost/${postId}`, config)
      .then((res) => {
        const newData = data.filter((item) => {
          return item._id !== res.data;
        });
        setData(newData);
      });
  };

  return (
    <>
      <Navbar />
      {fetchingData && (
        <Page alignItems="center">
          <CircularProgress color="secondary" />
        </Page>
      )}
      {!fetchingData && Array.isArray(data) && data.length === 0 && (
        <Page alignItems="center">
          <Typography variant="caption" align="center">
            There is no post to show.
          </Typography>
        </Page>
      )}
      {!fetchingData &&
        Array.isArray(data) &&
        data.length > 0 &&
        data.map((item) => (
          <div className="home" key={item._id}>
            <PostCard
              item={item}
              likePost={likePost}
              unlikePost={unlikePost}
              bookmark={bookmark}
              removeBookmark={removeBookmark}
              makeComment={makeComment}
              deltePost={deletePost}
            />
          </div>
        ))}
    </>
  );
};

export default Home;
